import useOnClickOutside from "hooks/useOnClickOutside";

import React, { useContext, useEffect, useRef, useState } from "react";

import { DashboardContext } from "./DashboardContext";
import SidebarButton from "./Sidebar/SidebarButton";
import SidebarButtonGroup from "./Sidebar/SidebarButtonGroup";
import { SidebarNav } from "./Sidebar/SidebarConfig";
import SidebarHeader from "./Sidebar/SidebarHeader";
import SideToggleButton from "./Sidebar/SideToggleButton";

const DashboardSidebar = () => {
  const {
    handleSideToggle,
    sideToggle,
    headerToggle,
    setHeaderToggle,
    setSideToggle,
  } = useContext(DashboardContext);
  const wrapperRef = useRef();

  const [activeBtn, setActiveBtn] = useState("dashboard");

  useOnClickOutside(wrapperRef, () => {
    if (window.innerWidth < 1024) {
      setHeaderToggle(true);
    }
  });
  useEffect(() => {
    if (window.innerWidth < 1024) {
      setHeaderToggle(true);
    }
    const listener = window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        setHeaderToggle(false);
      } else {
        setHeaderToggle(true);
        setSideToggle(false);
      }
    });

    return () => {
      window.removeEventListener("resize", listener);
    };
  }, [activeBtn, setHeaderToggle, setSideToggle]);

  return (
    <div
      ref={wrapperRef}
      className={`lg:relative bg-sidebar/70   fixed flex flex-col h-screen transition-all duration-300 ease-in-out shadow-md z-50   ${
        sideToggle ? "lg:w-[80px]" : "lg:w-[300px] w-[min(75vw,400px)]"
      }  ${headerToggle && "lg:w-0 lg:translate-x-0 -translate-x-full  "}  
      
      `}
    >
      <SidebarHeader sideToggle={sideToggle} headerToggle={headerToggle} />

      <div className="flex flex-col  overflow-x-hidden h-full  justify-between   ">
        <div className="  grid grid-cols-1  hover:[overflow:overlay] transition-all duration-300 ease-linear   overflow-x-hidden    ">
          {SidebarNav.map((item, i) => {
            if (item.type === "separator") {
              return (
                <React.Fragment key={i}>
                  {!sideToggle && (
                    <label className="font-bold text-sm p-4 text-gray-500 tracking-tighter">
                      {item.title.toUpperCase()}
                    </label>
                  )}
                </React.Fragment>
              );
            }

            if (item.type === "group") {
              return (
                <SidebarButtonGroup
                  key={i}
                  sideToggle={sideToggle}
                  headerToggle={headerToggle}
                  title={item.title}
                  icon={item.icon}
                >
                  {item.children.map((subitem, i) => (
                    <SidebarButton
                      key={i}
                      path={subitem.path}
                      icon={subitem.icon}
                      title={subitem.title}
                      sideToggle={sideToggle}
                      setActiveBtn={setActiveBtn}
                      headerToggle={headerToggle}
                      type={subitem.type}
                    />
                  ))}
                </SidebarButtonGroup>
              );
            }
            return (
              <SidebarButton
                key={i}
                path={item.path}
                icon={item.icon}
                title={item.title}
                sideToggle={sideToggle}
                setActiveBtn={setActiveBtn}
                headerToggle={headerToggle}
                type={item.type}
              />
            );
          })}
        </div>

        <SideToggleButton
          handleSideToggle={handleSideToggle}
          sideToggle={sideToggle}
        />
      </div>
    </div>
  );
};

export default DashboardSidebar;
